// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__bGwao","description":"PatientConsentPreview_description__ZlYZu"};